import { WidgetConfig } from 'components/Dashboard/types';
import { KPIsWidgetEnum } from '../utils';
import CancellationsWidget from '../widgets/CancellationsWidget';
import DeviationJobsWidget from '../widgets/DeviationJobsWidget';
import VehicleFaultsWidget from '../widgets/VehicleFaultsWidget';
import DeliveryConditionWidget from '../widgets/DeliveryConditionWidget';
import DeliveredCarsWidget from '../widgets/management/DeliveredCarsWidget';
import InternalDeliveryTransportWidget from '../widgets/management/InternalDeliveryTransportWidget';
import CancellationReasonsWidget from '../widgets/management/CancellationReasonsWidget';
import BookedToChangesWidget from '../widgets/management/BookedToChangesWidget';
import CustomerSatisfactionWidget from '../widgets/management/CustomerSatisfactionWidget';
import ResourceUtilizationWidget from '../widgets/management/ResourceUtilizationWidget';
import TransportLeadTimeWidget from '../widgets/management/TransportLeadTimeWidget';
import TruckCoverageWidget from '../widgets/management/TruckCoverageWidget';
import { memo } from 'react';
import DashboardWidgetsWrapper from 'components/Dashboard/WidgetWrapper';
import { useDashboardControls } from 'contexts/Dashboard/useDashboardControls';

const widgetsConfig: WidgetConfig<KPIsWidgetEnum>[] = [
  {
    widgetType: KPIsWidgetEnum.Cancellations,
    component: memo(CancellationsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.DeviationJobs,
    component: memo(DeviationJobsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.VehicleFaults,
    component: memo(VehicleFaultsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.DeliveryCondition,
    component: memo(DeliveryConditionWidget),
  },
  // Ledningsrapporten till RM — ordningen följer Alexanders punktlista.
  {
    widgetType: KPIsWidgetEnum.DeliveredCars,
    component: memo(DeliveredCarsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.InternalDeliveryTransport,
    component: memo(InternalDeliveryTransportWidget),
  },
  {
    widgetType: KPIsWidgetEnum.CancellationReasons,
    component: memo(CancellationReasonsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.BookedToChanges,
    component: memo(BookedToChangesWidget),
  },
  {
    widgetType: KPIsWidgetEnum.CustomerSatisfaction,
    component: memo(CustomerSatisfactionWidget),
  },
  {
    widgetType: KPIsWidgetEnum.ResourceUtilization,
    component: memo(ResourceUtilizationWidget),
  },
  {
    widgetType: KPIsWidgetEnum.TruckCoverage,
    component: memo(TruckCoverageWidget),
  },
  {
    widgetType: KPIsWidgetEnum.TransportLeadTime,
    component: memo(TransportLeadTimeWidget),
  },
];

const RiddermarkDashboardKPIs = () => {
  const {
    dashboardState: { widgets },
  } = useDashboardControls();

  const getIsActive = (widgetType: KPIsWidgetEnum) => {
    return widgets.some(
      (w) => w.identifier === widgetType && w.active === true
    );
  };

  return (
    <DashboardWidgetsWrapper>
      {widgetsConfig.map(
        ({ widgetType, component: Component }) =>
          getIsActive(widgetType) && <Component key={widgetType} />
      )}
    </DashboardWidgetsWrapper>
  );
};

export default RiddermarkDashboardKPIs;
